module.exports = __webpack_public_path__ + "img/the-netherlands-endocrine-nutritional-metabolic-diseases-female.e42ab044.png";